import { render, staticRenderFns } from "./AttributesView.vue?vue&type=template&id=1ecb344d&"
import script from "./AttributesView.vue?vue&type=script&lang=ts&"
export * from "./AttributesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports